import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import ChannelsPage from './ChannelsPage';
import FavouritesPage from './FavouritesPage';
import WatchlistPage from './WatchlistPage';
import RegisterPage from './RegisterPage';
import LoginPage from './LoginPage';
import EmailVerificationPage from './EmailVerificationPage';
import ResetPasswordPage from './ResetPasswordPage';
import ResetPasswordConfirmPage from './ResetPasswordConfirmPage';
import EditRecapPage from './pages/EditRecapPage';
import AdminSuggestionsPage from './pages/AdminSuggestionsPage';
import { AdminAddChannelPage } from './pages/AdminAddChannelPage';
import { AdminThumbnailMatchesPage } from './pages/AdminThumbnailMatchesPage';
import AdminPendingChannelsPage from './pages/AdminPendingChannelsPage';
import AdminDashboard from './pages/AdminDashboard';
import GenresPage from './pages/GenresPage';
import ConsolePlayerTest from './pages/ConsolePlayerTest';
import AdminRoute from './components/AdminRoute';
import { AuthProvider } from './AuthContext';
import { ModalProvider } from './context/ModalContext';
import { WatchlistProvider } from './context/WatchlistContext';
import { FavoritesProvider } from './FavoritesContext';
import { ThemeProvider } from './context/ThemeContext';
import { Toaster } from 'react-hot-toast';
import './index.css';
import './components/console_frame_bevel_button.css';
import { registerServiceWorker, setupInstallPrompt } from './utils/pwa';

// Register service worker and setup PWA features
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    registerServiceWorker();
  });
}

// Setup PWA install prompt
setupInstallPrompt();

const root = createRoot(document.getElementById('root')!);

root.render(
  <StrictMode>
    <HelmetProvider>
      <Router>
        <Toaster position="top-right" reverseOrder={false} />
        <AuthProvider>
          <ModalProvider>
            <ThemeProvider>
              <WatchlistProvider>
                <FavoritesProvider>
                <Routes>
                  <Route path="/" element={<App />} />
                  <Route path="/recaps/channel/:channelId" element={<App />} />
                  <Route path="/channels" element={<ChannelsPage />} />
                  <Route path="/genres" element={<GenresPage />} />
                  <Route path="/console-player-test" element={<ConsolePlayerTest />} />
                  <Route path="/favourites" element={<FavouritesPage />} />
                  <Route path="/watchlist" element={<WatchlistPage />} />
                  <Route path="/register" element={<RegisterPage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/verify-email" element={<EmailVerificationPage />} />
                  <Route path="/reset-password" element={<ResetPasswordPage />} />
                  <Route path="/reset-password-confirm" element={<ResetPasswordConfirmPage />} />
                  <Route path="/recaps/:id/edit" element={<AdminRoute />}>
                    <Route index element={<EditRecapPage />} />
                  </Route>
                  <Route path="/admin" element={<AdminRoute />}>
                    <Route index element={<AdminDashboard />} />
                  </Route>
                  <Route path="/admin/suggestions" element={<AdminRoute />}>
                    <Route index element={<AdminSuggestionsPage />} />
                  </Route>
                  <Route path="/admin/add-channel" element={<AdminRoute />}>
                    <Route index element={<AdminAddChannelPage />} />
                  </Route>
                  <Route path="/admin/thumbnail-matches" element={<AdminRoute />}>
                    <Route index element={<AdminThumbnailMatchesPage />} />
                  </Route>
                  <Route path="/admin/pending-channels" element={<AdminRoute />}>
                    <Route index element={<AdminPendingChannelsPage />} />
                  </Route>
                </Routes>
              </FavoritesProvider>
            </WatchlistProvider>
          </ThemeProvider>
          </ModalProvider>
        </AuthProvider>
      </Router>
    </HelmetProvider>
  </StrictMode>
);
